import { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { enqueueSnackbar } from 'notistack'
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Typography } from '@mui/material'

import { AppContext } from '/providers/app-context'
import { duplicateTemplate } from '/providers/templates-api'
import ActionErrorDialog from '/components/action-error-dialog'
import useActionErrorDialog from '/components/use-action-error-dialog'
import { setCurrentTemplateId } from '/utils/current-template'

const DuplicateTemplateDialog = ({ open, onClose, template }) => {
  const { apiSource, apiKey, refreshTemplates, setProcessing } = useContext(AppContext)
  const navigate = useNavigate()
  const [newTemplateName, setNewTemplateName] = useState('')
  const { actionError, errorDialogOpen, setErrorDialogOpen, showActionError } = useActionErrorDialog()

  const create = async () => {
    if (!template || newTemplateName.length < 5) return
    setProcessing(true)
    enqueueSnackbar({ message: 'Creating new template', variant: 'light' })
    const result = await duplicateTemplate({ apiSource, apiKey, templateId: template.template_id, newtemplateName: newTemplateName })
    setProcessing(false)

    if (result?.error || result?.ok === false) {
      showActionError(result?.error, 'Error duplicating template')
      return
    }

    const newTemplateId = result.template.template_id
    setCurrentTemplateId(newTemplateId)
    enqueueSnackbar({ message: 'Template created', variant: 'success' })
    await refreshTemplates()
    onClose()
    navigate(`/templates/${newTemplateId}/edit`, { replace: true })
  }

  return (
    <>
      <Dialog open={open} onClose={onClose} fullWidth maxWidth='sm'>
        <DialogTitle>Duplicate template</DialogTitle>
        <DialogContent className='flex flex-col gap-5'>
          <Typography>You are creating a duplicate of: {template?.name}</Typography>
          <TextField
            autoFocus
            label='New template name (max length 40)'
            value={newTemplateName}
            slotProps={{ inputLabel: { shrink: true } }}
            onChange={event => setNewTemplateName(event.target.value.substring(0, 40))}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button variant='contained' onClick={create} disabled={newTemplateName.length < 5}>Create duplicate</Button>
        </DialogActions>
      </Dialog>
      <ActionErrorDialog title='Template duplication failed' open={errorDialogOpen} setOpen={setErrorDialogOpen} error={actionError} />
    </>
  )
}

export default DuplicateTemplateDialog
